const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  async fetchList({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/teacher/class-list`);
      commit('SET_ITEM', data);
      return data;
    } catch (err) {
      throw err;
    }
  },
  async fetchListLite({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/teacher-lite`);
      commit('SET_ITEM', data);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchGenerateUrl({ commit }, { courseId, classId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/teacher-lite/generate-url/classroom/${classId}/course/${courseId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async checkStatusImportExport({ commit }, { courseId, classId, classSectionId }) {
    try {
      let url;
      if (!classSectionId) {
        url = `/api/export/classroom/${classId}/course/${courseId}/status`;
      } else {
        url = `/api/export/class-section/${classSectionId}/status`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchGenerateUrlSchoolName({ commit }, { schoolName, cityId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/master-school/detail?cityId=${cityId}&schoolName=${schoolName}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async guideCheck({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/teacher-lite/guide`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  guideCheckLoad({ commit }, payload) {
    return window.axios.put(`/api/teacher-lite/guide/`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListLiteDetail({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/teacher-lite/classroom/${payload}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchClassroomCourseName({ commit }, { classId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/${classId}/course/${courseId}/name`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListClassroomCourse({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/syllabus-teacher/classroom-course-list`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListClassroomCourseDetail({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/syllabus-teacher/${payload}/classroom-course-list`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  async fetchListStudent({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/student/class`);
      commit('SET_ITEM', data);
      return data;
    } catch (err) {
      throw err;
    }
  },
  async fetchListStudentLite({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/student-lite`);
      commit('SET_ITEM', data);
      return data;
    } catch (err) {
      throw err;
    }
  },
  async fetchListParent({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/parent/class/student/${payload.studentId}`);
      commit('SET_ITEM', data);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  savelite({ commit }, payload) {
    return window.axios.post('/api/teacher-lite/classroom', payload);
  },
  // eslint-disable-next-line no-unused-vars
  updatelite({ commit }, payload) {
    return window.axios.put(`/api/teacher-lite/classroom/${payload.id}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  joinClass({ commit }, payload) {
    return window.axios.post('/api/student-lite/join', payload);
  },
  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/teacher-lite/classroom/${payload.classroomId}`);
  }

  // async fetchList({ commit }) {
  //   let data = [
  //     { classroomId: 27, name: 'X-IPA 1', yearPeriode: '2019-2020' },
  //     { classroomId: 28, name: 'X-IPA 2', yearPeriode: '2012 - 2019' }
  //   ];
  //   commit('SET_ITEM', data);
  // }
};

export default { namespaced, state, getters, mutations, actions };
